/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChargePaymentMethodRequest
 */
export interface ChargePaymentMethodRequest {
    /**
     * Gondola PaymentMethod UUID to charge.
     * @type {string}
     * @memberof ChargePaymentMethodRequest
     */
    paymentMethodId: string;
    /**
     * Charge amount in major units of the currency (e.g. 49.99 for $49.99). Caller is responsible for keeping precision sensible (two decimals for non-zero-decimal currencies).
     * @type {number}
     * @memberof ChargePaymentMethodRequest
     */
    amount: number;
    /**
     * ISO currency code (lowercased server-side). Zero-decimal currencies (JPY, KRW, CLP, etc.) are rejected by the validator.
     * @type {string}
     * @memberof ChargePaymentMethodRequest
     */
    currency: string;
    /**
     * Stripe Idempotency-Key. Reuse the same key when retrying a failed charge to avoid double-charging. Callers should derive deterministically from a stable identifier (e.g. `charge-{booking_id}`).
     * @type {string}
     * @memberof ChargePaymentMethodRequest
     */
    idempotencyKey: string;
    /**
     * Optional Gondola booking id — attached to Stripe metadata for traceability when reconciling.
     * @type {string}
     * @memberof ChargePaymentMethodRequest
     */
    bookingId?: string | null;
    /**
     * Route to STRIPE_SECRET_KEY_TEST instead of the live key. Matches the existing charge_payment_method.py script's --test flag.
     * @type {boolean}
     * @memberof ChargePaymentMethodRequest
     */
    test?: boolean;
    /**
     * Stripe PaymentIntent capture method. `automatic` charges immediately; `manual` authorizes funds and leaves the intent in `requires_capture` for a later capture call.
     * @type {string}
     * @memberof ChargePaymentMethodRequest
     */
    captureMethod?: ChargePaymentMethodRequestCaptureMethodEnum;
    /**
     * True when no user initiated this charge — an Auto Save / rate-update rebooking running on a schedule. Such charges are off-session with no 3DS and no one present to respond, which is the shape Stripe Radar scores hardest, so a `highest` risk verdict on one is NOT trusted enough to auto-block the account; it alerts instead. Set by api_search whenever the booking carries a `rate_update_type`.
     * @type {boolean}
     * @memberof ChargePaymentMethodRequest
     */
    unattended?: boolean;
}


/**
 * @export
 */
export const ChargePaymentMethodRequestCaptureMethodEnum = {
    Automatic: 'automatic',
    Manual: 'manual'
} as const;
export type ChargePaymentMethodRequestCaptureMethodEnum = typeof ChargePaymentMethodRequestCaptureMethodEnum[keyof typeof ChargePaymentMethodRequestCaptureMethodEnum];


/**
 * Check if a given object implements the ChargePaymentMethodRequest interface.
 */
export function instanceOfChargePaymentMethodRequest(value: object): value is ChargePaymentMethodRequest {
    if (!('paymentMethodId' in value) || value['paymentMethodId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('idempotencyKey' in value) || value['idempotencyKey'] === undefined) return false;
    return true;
}

export function ChargePaymentMethodRequestFromJSON(json: any): ChargePaymentMethodRequest {
    return ChargePaymentMethodRequestFromJSONTyped(json, false);
}

export function ChargePaymentMethodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChargePaymentMethodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethodId': json['payment_method_id'],
        'amount': json['amount'],
        'currency': json['currency'],
        'idempotencyKey': json['idempotency_key'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'test': json['test'] == null ? undefined : json['test'],
        'captureMethod': json['capture_method'] == null ? undefined : json['capture_method'],
        'unattended': json['unattended'] == null ? undefined : json['unattended'],
    };
}

export function ChargePaymentMethodRequestToJSON(json: any): ChargePaymentMethodRequest {
    return ChargePaymentMethodRequestToJSONTyped(json, false);
}

export function ChargePaymentMethodRequestToJSONTyped(value?: ChargePaymentMethodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_id': value['paymentMethodId'],
        'amount': value['amount'],
        'currency': value['currency'],
        'idempotency_key': value['idempotencyKey'],
        'booking_id': value['bookingId'],
        'test': value['test'],
        'capture_method': value['captureMethod'],
        'unattended': value['unattended'],
    };
}

